// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container {\n  display: flex;\n  flex-direction: column;\n  min-width: 450px;\n}\n\ninput[type=file] {\n  width: 100%;\n  cursor: not-allowed;\n  border: 2px solid #868e96;\n  box-shadow: none;\n  box-sizing: border-box;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
